module.exports = __webpack_public_path__ + "static/media/台灣香腸.a4c854b7.jpg";